import none from '../../img/leoLogo.png'
import gharchsokhari from '../../img/fried/gharchsokhari.jpg'
import sokhari_1_nafare from '../../img/fried/sokhari_1_nafare.jpg'
import sokhari_2_nafare from '../../img/fried/sokhari_2_nafare.jpg'

export const frieds=[
    {
      "id": "41",
      "title": "سینی سوخاری یک نفره",
      "desciption": "پیاز سوخاری قارچ فیله سوسیس چینی سیب زمینی",
      "price": "360",
      "image": sokhari_1_nafare
    },
    {
      "id": "42",
      "title": "سینی سوخاری دو نفره",
      "desciption": "پیاز سوخاری قارچ فیله سوسیس چینی سیب زمینی",
      "price": "510",
      "image": sokhari_2_nafare
    },
    {
      "id": "43",
      "title": "فیله سوخاری ۳ تکه",
      "desciption": "",
      "price": "340",
      "image": none
    },
    {
      "id": "44",
      "title": "قارچ سوخاری",
      "desciption": "هشت عدد قارچ-صد گرم سیب زمینی",
      "price": "210",
      "image": gharchsokhari
    },
    {
      "id": "45",
      "title": "توشه",
      "desciption": "فیله + برگر + سیب زمینی + قارچ + نوشابه",
      "price": "550",
      "image": none
    },
    {
      "id": "46",
      "title": "کولا فلوط",
      "desciption": "نوشابه کوکا کولا + بستنی وانیل",
      "price": "198",
      "image": none
    },
  ]